import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="border-t border-border/60 bg-muted/30 mt-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12 grid gap-8 md:grid-cols-4 text-sm">
        <div>
          <div className="flex items-center gap-2 font-heading font-bold mb-3">
            <div className="w-8 h-8 rounded-lg bg-primary text-primary-foreground grid place-items-center text-xs">BP</div>
            TheBillPro
          </div>
          <p className="text-muted-foreground">Simple billing. Powerful business management. Built for Indian small businesses.</p>
        </div>
        <FooterCol title="Product" links={[
          ["Features", "/features"],
          ["Pricing", "/pricing"],
          ["GST Billing", "/gst-billing"],
          ["FAQ", "/faq"],
        ]} />
        <FooterCol title="Company" links={[
          ["Contact", "/contact"],
          ["Privacy Policy", "/privacy"],
          ["Terms & Conditions", "/terms"],
        ]} />
        <FooterCol title="Get started" links={[
          ["Sign up", "/signup"],
          ["Login", "/login"],
        ]} />
      </div>
      <div className="border-t border-border/60 py-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} TheBillPro · Built for Indian small businesses
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="font-heading font-semibold mb-3">{title}</div>
      <ul className="space-y-2 text-muted-foreground">
        {links.map(([label, to]) => (
          <li key={to}><Link to={to} className="hover:text-foreground">{label}</Link></li>
        ))}
      </ul>
    </div>
  );
}
